import permission, { RESOURCE_ACTIVO_FIJO_PG } from '@/auth/permissions/modules/activoFijoPg'
import {
    ROUTE_ACTIVACION_ACTIVO_FIJO,
    ROUTE_APROBAR_TRANSFERENCIA,
    ROUTE_CREAR_ACTIVO_FIJO,
    ROUTE_GESTION_ACTIVOS_FIJOS,
    ROUTE_GESTION_AVALUOS,
    ROUTE_GESTION_SOLICITUDES_TRANSFERENCIA,
    ROUTE_LIQUIDACION_ACTIVO_FIJO,
    ROUTE_REGISTRO_AVALUOS,
    ROUTE_SOLICITAR_TRANSFERENCIA,
} from '@/router/routes/activo-fijo-pg/names'
import { defineMenu } from '@/utils/menu'

const { transacciones } = permission
export default defineMenu([
    {
        title: 'activo_fijo_pg.subopciones.crear_activo_fijo',
        resource: RESOURCE_ACTIVO_FIJO_PG,
        action: transacciones.crearActivoFijo,
        route: ROUTE_CREAR_ACTIVO_FIJO,
    },
    {
        title: 'activo_fijo_pg.subopciones.gestion_activo_fijo',
        resource: RESOURCE_ACTIVO_FIJO_PG,
        action: transacciones.gestionActivosFijos,
        route: ROUTE_GESTION_ACTIVOS_FIJOS,
    },
    {
        title: 'activo_fijo_pg.subopciones.activacion_activo_fijo',
        resource: RESOURCE_ACTIVO_FIJO_PG,
        action: transacciones.activacionActivoFijo,
        route: ROUTE_ACTIVACION_ACTIVO_FIJO,
    },
    {
        title: 'activo_fijo_pg.subopciones.registro_avaluos',
        resource: RESOURCE_ACTIVO_FIJO_PG,
        action: transacciones.registroAvaluo,
        route: ROUTE_REGISTRO_AVALUOS,
    },
    {
        title: 'activo_fijo_pg.subopciones.gestion_avaluos',
        resource: RESOURCE_ACTIVO_FIJO_PG,
        action: transacciones.gestionAvaluos,
        route: ROUTE_GESTION_AVALUOS,
    },
    {
        title: 'activo_fijo_pg.subopciones.liquidacion_activo_fijo',
        resource: RESOURCE_ACTIVO_FIJO_PG,
        action: transacciones.liquidacionActivoFijo,
        route: ROUTE_LIQUIDACION_ACTIVO_FIJO,
    },
    {
        title: 'activo_fijo_pg.subopciones.solicitar_transferencia',
        resource: RESOURCE_ACTIVO_FIJO_PG,
        action: transacciones.solicitarTransferencia,
        route: ROUTE_SOLICITAR_TRANSFERENCIA,
    },
    {
        title: 'activo_fijo_pg.subopciones.gestion_solicitudes_transferencia',
        resource: RESOURCE_ACTIVO_FIJO_PG,
        action: transacciones.gestionSolicitudesTransferencia,
        route: ROUTE_GESTION_SOLICITUDES_TRANSFERENCIA,
    },
    {
        title: 'activo_fijo_pg.subopciones.aprobar_transferencia',
        resource: RESOURCE_ACTIVO_FIJO_PG,
        action: transacciones.aprobarTransferencia,
        route: ROUTE_APROBAR_TRANSFERENCIA,
    },
])
